export default function () {
	// El cierre de sesion por token caducado no se gestiona aqui, sino en
	// plugins/axios.js: es el unico punto donde se ve tanto el 401 del servidor
	// como el aborto que hace este modulo cuando el token ya ha caducado en
	// cliente. Alli se limpia la sesion, se avisa al socio y se le lleva a
	// /acceder.
	//
	// Los errores de $auth (login, logout, carga del usuario) se dejan propagar
	// para que cada formulario los muestre con ApiHelper.handleErrors.
}
